import { useQuery } from "@tanstack/react-query";
import api from "../../../api";

export const GET_LAYOUTS_QUERY_KEY = ["getLayouts"];

const useGetLayouts = () => {
  const { data, isPending } = useQuery({
    queryKey: GET_LAYOUTS_QUERY_KEY,
    queryFn: () => api.getLayouts(),
    select: ({ data: response }) => response
  });

  return { data, isPending };
};

export default useGetLayouts;
